module.exports = __webpack_public_path__ + "static/media/menu.baa2af7a.jpg";